"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classNames = require("../customPropTypes/classNames");
var _spacing = require("../customPropTypes/spacing");
var _SvgIcon = _interopRequireDefault(require("../SvgIcon"));
var _jsxRuntime = require("react/jsx-runtime");
var _path;
function IconPen(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SvgIcon["default"], (0, _extends2["default"])({
    viewBox: "0 0 48 48"
  }, props, {
    children: _path || (_path = /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M29.6 30.8c1.2-.1 1.8-.9 1.8-2.6v-9.6l-.5-.8c-.3-.4-.7-.6-1.2-.6v-.8h3.6L39 26.5v-6.8c0-1.6-.6-2.5-1.7-2.5v-.7h4.1v.8c-1.1 0-1.7.9-1.7 2.5v11.9H39l-6.8-12v8.6c0 1.8.5 2.6 1.9 2.7v.8h-4.2v-1zm-6.9-7.4c1.3 0 1.9-.9 2.2-3h.5v7.1h-.5c-.2-2.3-.9-3.3-2.4-3.3h-.1v5.3c0 1.3.3 1.5 1.4 1.5 2.2 0 3.3-1.5 4.2-5.1h.5l-.2 5.8H18.1V31c1.3-.1 1.6-.4 1.6-1.8V18.8c0-1.3-.3-1.7-1.5-1.7h-.1v-.7H28l.2 5.4-.7.1c-.5-3.3-1.7-4.9-3.9-4.9-.9 0-1.3.5-1.3 1.4v4.9c.1.1.3.1.4.1zm-12 .4v-5.4c0-1 .5-1.4 1.5-1.4 1.5 0 2.1.9 2.1 3 0 2.9-.7 3.8-2.9 3.8h-.7zm-4 7.8h5.6v-.8H12c-1.1 0-1.4-.2-1.4-1.4v-4.9h.7c3.7 0 5.6-1.4 5.6-4.1 0-2.8-1.7-4-5.1-4H6.7v.7h.2c1 0 1.4.3 1.4 1.4v10.8c0 1.2-.3 1.5-1.6 1.5v.8z"
    }))
  }));
}
process.env.NODE_ENV !== "production" ? IconPen.propTypes = {
  /** size of icon */
  size: _propTypes["default"].oneOf(['sm', 'smd', 'md', 'mlg', 'lg', 'none']),
  /** CSS class to use, if any */
  className: _classNames.classNamePropTypes,
  /** color, if not inheriting from parent's text color */
  color: _propTypes["default"].oneOf(['ink', 'blurple', 'asphalt', 'lava', 'emerald', 'white']),
  /** margin for icon, if any */
  margin: _spacing.marginPropTypes
} : void 0;
IconPen.defaultProps = {
  size: 'md',
  className: '',
  margin: null,
  color: null
};
var _default = IconPen;
exports["default"] = _default;